import { MIN_PASSWORD_LENGTH } from "../../auth/passwordRules";

/**
 * The password rules as four lines that tick while the person types, in place of the one sentence
 * (`PASSWORD_HINT`) that listed them. Drawn in `prototype/kund/pages-auth.js`, approved 2026-09-24.
 *
 * **This is not the policy and it gates nothing.** The server decides, exactly as
 * `app/auth/passwordRules.ts` says: the Supabase project refuses a weak password and
 * `weakPasswordMessage` turns its reasons into words. The list only reads the same four things the
 * project asks for, so a person sees which one is missing before a submit is spent on learning it.
 * The submit button still waits for the length and the repeat and nothing else, as it did.
 *
 * The character sets are GoTrue's for `password_requirements = "lower_upper_letters_digits_symbols"`
 * (`supabase/config.toml`), so a letter such as å counts as neither case and a space is not a
 * symbol, the same as on the server. If the two ever drift, the list is wrong about a tick and the
 * server is still right about the password.
 */

const LOWER = /[a-z]/;
const UPPER = /[A-Z]/;
const DIGIT = /[0-9]/;
const SYMBOL = /[!@#$%^&*()_+\-=[\]{};'\\:"|<>?,./`~]/;

export interface PasswordRule {
  key: "length" | "letters" | "digit" | "symbol";
  label: string;
  met: boolean;
}

export function passwordChecklist(password: string): PasswordRule[] {
  return [
    { key: "length", label: `Minst ${MIN_PASSWORD_LENGTH} tecken`, met: password.length >= MIN_PASSWORD_LENGTH },
    { key: "letters", label: "Stora och små bokstäver", met: LOWER.test(password) && UPPER.test(password) },
    { key: "digit", label: "En siffra", met: DIGIT.test(password) },
    { key: "symbol", label: "Ett specialtecken", met: SYMBOL.test(password) }
  ];
}
